<template>
  <div class="menus-list">
    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="list-hero">
            <p class="list-crumb">Admin / Menús</p>
            <h1 class="list-title">Gestión de Menús</h1>
            <p class="list-subtitle">
              Administre los menús de navegación del sistema.
            </p>
          </div>
        </v-flex>
        <v-flex xs12>
          <v-card class="menus-panel">
            <v-card-text class="menus-card__toolbar">
              <v-layout row wrap align-center>
                <v-flex md7 sm8 xs12>
                  <v-text-field
                    clearable
                    flat
                    hide-details
                    placeholder="Buscar menú..."
                    solo
                    class="menus-search"
                    v-model="search"
                    append-icon="search"
                    @keyup.enter="loadMenus"
                    @click:clear="onSearchClear"
                    @click:append="loadMenus"
                  ></v-text-field>
                </v-flex>
                <v-flex md5 sm4 xs12 class="toolbar-actions">
                  <v-btn-toggle
                    v-model="viewMode"
                    mandatory
                    class="view-toggle"
                  >
                    <v-btn value="list" flat small>
                      <v-icon small>view_list</v-icon>
                    </v-btn>
                    <v-btn value="tree" flat small>
                      <v-icon small>account_tree</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                  <v-btn
                    @click="openDialog()"
                    color="#e5252a"
                    dark
                    class="btn-nuevo"
                  >
                    <v-icon left>add</v-icon>Nuevo Menú
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-text class="pa-0 menus-content-wrap">
              <!-- VISTA LISTA - Desktop con paginación -->
              <v-data-table
                v-if="viewMode === 'list' && !$vuetify.breakpoint.smAndDown"
                class="menus-table"
                :headers="headers"
                :items="menus"
                :loading="loading"
                :pagination.sync="pagination"
                :rows-per-page-items="rowsPerPageItems"
                rows-per-page-text="Filas por página:"
                no-data-text="No hay menús disponibles"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.title }}</td>
                  <td>{{ props.item.route }}</td>
                  <td>{{ props.item.icon || '---' }}</td>
                  <td>{{ props.item.order }}</td>
                  <td>
                    <v-chip
                      :class="
                        props.item.isActive
                          ? 'status-chip status-chip--active'
                          : 'status-chip status-chip--inactive'
                      "
                      text-color="white"
                      small
                    >
                      {{ props.item.isActive ? 'Activo' : 'Inactivo' }}
                    </v-chip>
                  </td>
                  <td>
                    <v-btn
                      @click="openDialog(props.item)"
                      class="table-action-btn table-action-btn--edit"
                      flat
                      icon
                      small
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn
                      @click="deleteMenu(props.item.id)"
                      class="table-action-btn table-action-btn--delete"
                      flat
                      icon
                      small
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
                <template slot="pageText" slot-scope="props">
                  {{ props.pageStart }}-{{ props.pageStop }} de
                  {{ props.itemsLength }}
                </template>
              </v-data-table>

              <!-- VISTA LISTA - Mobile con paginación -->
              <div
                v-else-if="viewMode === 'list' && $vuetify.breakpoint.smAndDown"
                class="menus-mobile-list"
              >
                <v-container fluid class="pa-3">
                  <v-layout row wrap>
                    <v-flex xs12 v-if="!menus.length && !loading">
                      <v-alert type="info" value="true" class="mb-0">
                        No hay menús disponibles.
                      </v-alert>
                    </v-flex>
                    <v-flex
                      xs12
                      v-for="menu in paginatedMenus"
                      :key="menu.id"
                      class="mb-3"
                    >
                      <v-card class="menu-mobile-card">
                        <div class="menu-mobile-card__head">
                          <div>
                            <p class="menu-mobile-card__title">
                              {{ menu.title }}
                            </p>
                            <p class="menu-mobile-card__route">
                              {{ menu.route || 'Sin ruta' }}
                            </p>
                          </div>
                          <v-chip
                            :class="
                              menu.isActive
                                ? 'status-chip status-chip--active'
                                : 'status-chip status-chip--inactive'
                            "
                            text-color="white"
                            small
                          >
                            {{ menu.isActive ? 'Activo' : 'Inactivo' }}
                          </v-chip>
                        </div>

                        <v-divider></v-divider>

                        <div class="menu-mobile-card__body">
                          <div class="menu-mobile-card__row">
                            <span class="label">Icono</span>
                            <span class="value">{{ menu.icon || '---' }}</span>
                          </div>
                          <div class="menu-mobile-card__row">
                            <span class="label">Orden</span>
                            <span class="value">{{ menu.order }}</span>
                          </div>
                          <div class="menu-mobile-card__row">
                            <span class="label">Menú padre</span>
                            <span class="value">{{
                              resolveParentTitle(menu.parentId)
                            }}</span>
                          </div>
                        </div>

                        <div class="menu-mobile-card__actions">
                          <v-btn
                            small
                            dark
                            class="mobile-action-btn mobile-action-btn--edit"
                            @click="openDialog(menu)"
                          >
                            <v-icon small left>edit</v-icon>
                            Editar
                          </v-btn>
                          <v-btn
                            small
                            dark
                            class="mobile-action-btn mobile-action-btn--delete"
                            @click="deleteMenu(menu.id)"
                          >
                            <v-icon small left>delete</v-icon>
                            Eliminar
                          </v-btn>
                        </div>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <div v-if="totalPages > 1" class="mobile-pagination">
                    <v-pagination
                      v-model="pagination.page"
                      :length="totalPages"
                      :total-visible="5"
                      color="#e5252a"
                    ></v-pagination>
                  </div>
                </v-container>
              </div>

              <!-- VISTA ÁRBOL -->
              <div v-else-if="viewMode === 'tree'" class="menus-tree-wrapper">
                <div class="tree-toolbar">
                  <span class="tree-toolbar__title">
                    <v-icon small color="#254f87">account_tree</v-icon>
                    Estructura jerárquica ({{ rootMenus }} raíz /
                    {{ totalChildren }} hijos)
                  </span>
                  <v-spacer></v-spacer>
                  <v-btn
                    flat
                    small
                    class="tree-action-btn"
                    @click="expandAllTree"
                  >
                    <v-icon small left>unfold_more</v-icon>Expandir todo
                  </v-btn>
                  <v-btn
                    flat
                    small
                    class="tree-action-btn"
                    @click="collapseAllTree"
                  >
                    <v-icon small left>unfold_less</v-icon>Colapsar todo
                  </v-btn>
                </div>
                <v-divider></v-divider>
                <div class="tree-body">
                  <v-alert
                    v-if="!treeData.length && !loading"
                    type="info"
                    value="true"
                    class="ma-3"
                  >
                    No hay menús para mostrar.
                  </v-alert>
                  <v-treeview
                    v-else
                    ref="menusTree"
                    :items="treeData"
                    :open.sync="openNodes"
                    item-key="id"
                    item-text="title"
                    item-children="children"
                    hoverable
                    transition
                    open-on-click
                    class="menus-tree"
                  >
                    <template slot="prepend" slot-scope="{ item, open }">
                      <v-icon
                        v-if="item.children && item.children.length"
                        :color="open ? '#e5252a' : '#254f87'"
                      >
                        {{ open ? 'folder_open' : 'folder' }}
                      </v-icon>
                      <v-icon v-else color="#c79a2b">
                        {{ item.icon || 'insert_drive_file' }}
                      </v-icon>
                    </template>
                    <template slot="label" slot-scope="{ item }">
                      <div class="tree-node">
                        <div class="tree-node__main">
                          <span class="tree-node__title">{{ item.title }}</span>
                          <span
                            class="tree-node__badge"
                            v-if="item.children && item.children.length"
                          >
                            {{ item.children.length }}
                          </span>
                        </div>
                        <div class="tree-node__meta">
                          <span class="tree-node__route" v-if="item.route">
                            <v-icon x-small>link</v-icon>{{ item.route }}
                          </span>
                          <span class="tree-node__icon-name" v-if="item.icon">
                            <v-icon x-small>style</v-icon>{{ item.icon }}
                          </span>
                          <v-chip
                            :class="
                              item.isActive
                                ? 'status-chip status-chip--active'
                                : 'status-chip status-chip--inactive'
                            "
                            text-color="white"
                            x-small
                          >
                            {{ item.isActive ? 'Activo' : 'Inactivo' }}
                          </v-chip>
                        </div>
                      </div>
                    </template>
                    <template slot="append" slot-scope="{ item }">
                      <v-btn
                        @click.stop="openDialog(item)"
                        class="tree-action-icon tree-action-icon--edit"
                        flat
                        icon
                        small
                      >
                        <v-icon small>edit</v-icon>
                      </v-btn>
                      <v-btn
                        @click.stop="deleteMenu(item.id)"
                        class="tree-action-icon tree-action-icon--delete"
                        flat
                        icon
                        small
                      >
                        <v-icon small>delete</v-icon>
                      </v-btn>
                    </template>
                  </v-treeview>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Dialog para crear/editar menú -->
    <v-dialog max-width="600" persistent v-model="dialog">
      <v-card class="menu-dialog-card">
        <v-card-title class="headline menu-dialog-title">
          {{ editingMenu.id ? 'Editar Menú' : 'Nuevo Menú' }}
        </v-card-title>

        <v-card-text>
          <v-form ref="form">
            <v-text-field
              v-model="editingMenu.title"
              label="Título"
              placeholder="Ej: Dashboard"
              required
              :rules="[v => !!v || 'El título es requerido']"
            ></v-text-field>

            <v-text-field
              v-model="editingMenu.route"
              label="Ruta"
              placeholder="Ej: /dashboard"
              required
              :rules="[v => !!v || 'La ruta es requerida']"
            ></v-text-field>

            <v-text-field
              v-model="editingMenu.icon"
              label="Icono"
              placeholder="Ej: dashboard"
              hint="Icono de Material Design"
            ></v-text-field>

            <v-select
              v-model="editingMenu.parentId"
              :items="menus"
              item-text="title"
              item-value="id"
              label="Menú Padre (opcional)"
              clearable
              placeholder="Selecciona un menú padre"
            ></v-select>

            <v-text-field
              v-model.number="editingMenu.order"
              label="Orden"
              type="number"
              placeholder="1, 2, 3..."
            ></v-text-field>

            <v-checkbox
              v-model="editingMenu.isActive"
              label="Activo"
            ></v-checkbox>
          </v-form>
        </v-card-text>

        <v-card-actions class="menu-dialog-actions">
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" flat color="#254f87">Cancelar</v-btn>
          <v-btn @click="saveMenu" color="#e5252a" dark :loading="saving">
            <v-icon left small>save</v-icon>Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <v-dialog max-width="350" persistent v-model="loading">
      <v-card>
        <v-card-text class="text-center py-4">
          <v-progress-circular
            color="primary"
            indeterminate
          ></v-progress-circular>
          <p class="mt-2">Cargando...</p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar de notificaciones -->
    <v-snackbar
      v-model="snack.show"
      :timeout="3500"
      :color="snack.color"
      right
      top
    >
      {{ snack.message }}
      <v-btn flat dark @click="snack.show = false">Cerrar</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import Api from '@/api/index'

export default {
  components: {},
  data() {
    return {
      menus: [],
      search: '',
      dialog: false,
      loading: false,
      saving: false,
      viewMode: 'list',
      openNodes: [],
      snack: {
        show: false,
        color: 'info',
        message: '',
      },
      pagination: {
        page: 1,
        rowsPerPage: 10,
        sortBy: 'order',
        descending: false,
      },
      rowsPerPageItems: [10, 25, 50, { text: 'Todos', value: -1 }],
      headers: [
        { text: 'Título', value: 'title' },
        { text: 'Ruta', value: 'route' },
        { text: 'Icono', value: 'icon' },
        { text: 'Orden', value: 'order' },
        { text: 'Estado', value: 'isActive' },
        { text: 'Acciones', sortable: false },
      ],
      editingMenu: {
        id: null,
        title: '',
        route: '',
        icon: '',
        order: 1,
        isActive: true,
        parentId: null,
      },
    }
  },
  computed: {
    treeData() {
      const map = {}
      const roots = []
      this.menus.forEach(m => {
        map[m.id] = { ...m, children: [] }
      })
      this.menus.forEach(m => {
        const node = map[m.id]
        if (m.parentId && map[m.parentId]) {
          map[m.parentId].children.push(node)
        } else {
          roots.push(node)
        }
      })
      const sortFn = (a, b) => (a.order || 0) - (b.order || 0)
      const sortRecursive = nodes => {
        nodes.sort(sortFn)
        nodes.forEach(n => n.children.length && sortRecursive(n.children))
      }
      sortRecursive(roots)
      return roots
    },
    rootMenus() {
      return this.treeData.length
    },
    totalChildren() {
      return this.menus.length - this.treeData.length
    },
    paginatedMenus() {
      if (this.pagination.rowsPerPage === -1) return this.menus
      const start = (this.pagination.page - 1) * this.pagination.rowsPerPage
      return this.menus.slice(start, start + this.pagination.rowsPerPage)
    },
    totalPages() {
      if (this.pagination.rowsPerPage === -1) return 1
      return Math.max(
        1,
        Math.ceil(this.menus.length / this.pagination.rowsPerPage)
      )
    },
  },
  mounted() {
    document.body.classList.add('admin-flush-top')
    this.loadMenus()
  },
  beforeDestroy() {
    document.body.classList.remove('admin-flush-top')
  },
  methods: {
    notify(message, color = 'info') {
      this.snack = { show: true, color, message }
    },
    async loadMenus() {
      this.loading = true
      try {
        const term = (this.search || '').trim()
        const response = await Api.Menu.getAll({ term })
        this.menus = response.data || response
      } catch (error) {
        this.notify('Error al cargar los menús', 'error')
      } finally {
        this.loading = false
      }
    },
    onSearchClear() {
      this.search = ''
      this.loadMenus()
    },
    openDialog(menu = null) {
      if (menu) {
        this.editingMenu = { ...menu }
      } else {
        this.editingMenu = {
          id: null,
          title: '',
          route: '',
          icon: '',
          order: 1,
          isActive: true,
          parentId: null,
        }
      }
      this.dialog = true
    },
    async saveMenu() {
      if (!this.$refs.form.validate()) return

      this.saving = true
      try {
        await Api.Menu.save(this.editingMenu)
        this.notify('Menú guardado correctamente', 'success')
        this.dialog = false
        this.loadMenus()
      } catch (error) {
        this.notify('Error al guardar el menú', 'error')
      } finally {
        this.saving = false
      }
    },
    async deleteMenu(id) {
      if (!confirm('¿Estás seguro de que deseas eliminar este menú?')) return

      try {
        await Api.Menu.delete(id)
        this.notify('Menú eliminado correctamente', 'success')
        this.loadMenus()
      } catch (error) {
        this.notify('Error al eliminar el menú', 'error')
      }
    },
    resolveParentTitle(parentId) {
      if (!parentId) return 'Raíz'
      const parent = this.menus.find(menu => menu.id === parentId)
      return parent ? parent.title : 'No definido'
    },
    expandAllTree() {
      this.openNodes = this.menus.map(m => m.id)
    },
    collapseAllTree() {
      this.openNodes = []
    },
  },
}
</script>

<style scoped>
.menus-list {
  --brand-primary: #e5252a;
  --brand-secondary: #254f87;
  --brand-accent: #c79a2b;
  --surface: #ffffff;
  --surface-soft: #f6f8fc;
  --text-primary: #172133;
  --text-muted: #5f6880;
  --border-soft: #e4e8f1;
  background: #f8fafc;
  min-height: 100vh;
  padding-bottom: 16px;
}

.list-hero {
  padding: 4px 0 8px;
}

.list-crumb {
  margin: 0;
  font-size: 13px;
  color: #64748b;
}

.list-title {
  margin: 4px 0;
  font-size: 32px;
  line-height: 1.1;
  color: #0f172a;
  font-weight: 700;
}

.list-subtitle {
  margin: 0;
  font-size: 14px;
  color: #475569;
}

.menus-panel {
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
  overflow: hidden;
  background: #ffffff;
}

.menus-card__toolbar {
  padding: 12px;
  border-bottom: 1px solid #e2e8f0;
}

.toolbar-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.menus-search {
  max-width: 100%;
}

.btn-nuevo {
  border-radius: 8px;
}

.menus-content-wrap {
  background: var(--surface-soft);
}

.menus-table {
  background: var(--surface);
}

.menus-table ::v-deep thead th {
  color: #64748b !important;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.2px;
  text-transform: uppercase;
  background: #f8fafc;
}

.menus-table ::v-deep tbody td {
  color: #334155;
  font-size: 14px;
  border-bottom: 1px solid #eef2f7;
}

.menus-table ::v-deep tbody tr:hover td {
  background: #f8fafc;
}

.status-chip {
  font-weight: 700;
}

.status-chip--active {
  background-color: #1f9d63 !important;
}

.status-chip--inactive {
  background-color: #d94848 !important;
}

.table-action-btn {
  margin: 0 2px;
}

.table-action-btn--edit {
  border: 1px solid rgba(37, 79, 135, 0.3) !important;
  color: #254f87 !important;
  background: rgba(37, 79, 135, 0.1) !important;
  box-shadow: none !important;
}

.table-action-btn--delete {
  border: 1px solid rgba(229, 37, 42, 0.3) !important;
  color: #e5252a !important;
  background: rgba(229, 37, 42, 0.1) !important;
  box-shadow: none !important;
}

.menus-mobile-list {
  background: var(--surface-soft);
}

.menu-mobile-card {
  border-radius: 14px;
  border: 1px solid var(--border-soft);
  box-shadow: 0 10px 28px rgba(20, 37, 70, 0.08);
  overflow: hidden;
}

.menu-mobile-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 14px;
  background: linear-gradient(
    135deg,
    rgba(37, 79, 135, 0.12),
    rgba(199, 154, 43, 0.1)
  );
}

.menu-mobile-card__title {
  margin: 0;
  color: var(--text-primary);
  font-weight: 700;
  font-size: 15px;
}

.menu-mobile-card__route {
  margin: 3px 0 0;
  color: var(--text-muted);
  font-size: 12px;
}

.menu-mobile-card__body {
  padding: 12px 14px;
}

.menu-mobile-card__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 0;
}

.menu-mobile-card__row .label {
  color: var(--text-muted);
  font-size: 12px;
  font-weight: 600;
}

.menu-mobile-card__row .value {
  color: var(--text-primary);
  font-size: 13px;
  font-weight: 600;
  text-align: right;
}

.menu-mobile-card__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 0 14px 14px;
}

.mobile-action-btn {
  border-radius: 9px;
}

.mobile-action-btn--edit {
  background-color: var(--brand-secondary) !important;
}

.mobile-action-btn--delete {
  background-color: var(--brand-primary) !important;
}

.menu-dialog-card {
  border-radius: 14px;
  overflow: hidden;
}

.menu-dialog-title {
  background: linear-gradient(
    90deg,
    rgba(37, 79, 135, 0.12),
    rgba(199, 154, 43, 0.14)
  );
  color: var(--brand-secondary);
  font-weight: 700;
}

.dialog-cancel-btn {
  color: var(--brand-secondary) !important;
}

/* === Toggle de vista === */
.view-toggle {
  margin-right: 12px;
  background: transparent !important;
  box-shadow: none !important;
  border: 1px solid var(--border-soft);
  border-radius: 10px;
  overflow: hidden;
}

.view-toggle ::v-deep .v-btn {
  margin: 0 !important;
  min-width: 40px;
  height: 36px;
  border-radius: 0 !important;
  color: var(--text-muted) !important;
  background: transparent !important;
}

.view-toggle ::v-deep .v-btn--active {
  background: linear-gradient(
    135deg,
    var(--brand-secondary),
    #1a3a63
  ) !important;
  color: #ffffff !important;
}

.view-toggle ::v-deep .v-btn--active .v-icon {
  color: #ffffff !important;
}

/* === Paginación móvil === */
.mobile-pagination {
  display: flex;
  justify-content: center;
  padding: 12px 0 4px;
}

.mobile-pagination ::v-deep .v-pagination__item--active {
  background-color: var(--brand-primary) !important;
  color: #ffffff !important;
}

/* === Vista árbol === */
.menus-tree-wrapper {
  background: var(--surface);
}

.tree-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: linear-gradient(
    90deg,
    rgba(37, 79, 135, 0.06),
    rgba(199, 154, 43, 0.04)
  );
}

.tree-toolbar__title {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--brand-secondary);
  font-weight: 700;
  font-size: 13px;
}

.tree-action-btn {
  color: var(--brand-secondary) !important;
  text-transform: none !important;
  font-weight: 600;
}

.tree-body {
  padding: 8px 4px;
  min-height: 240px;
}

.menus-tree ::v-deep .v-treeview-node__root {
  border-radius: 10px;
  margin: 2px 8px;
  padding: 6px 8px;
  min-height: 56px;
  transition: background-color 0.15s ease;
}

.menus-tree ::v-deep .v-treeview-node__root:hover {
  background: rgba(37, 79, 135, 0.06);
}

.menus-tree ::v-deep .v-treeview-node__toggle {
  color: var(--brand-secondary) !important;
}

.menus-tree ::v-deep .v-treeview-node__label {
  font-size: 13px;
}

.menus-tree ::v-deep .v-treeview-node__children {
  border-left: 2px dashed rgba(37, 79, 135, 0.18);
  margin-left: 24px;
  padding-left: 4px;
}

.tree-node {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 4px 0;
}

.tree-node__main {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tree-node__title {
  color: var(--text-primary);
  font-weight: 700;
  font-size: 13.5px;
}

.tree-node__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 18px;
  padding: 0 6px;
  border-radius: 10px;
  background: var(--brand-primary);
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
}

.tree-node__meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.tree-node__route,
.tree-node__icon-name {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--text-muted);
  font-size: 11.5px;
  font-weight: 500;
}

.tree-node__route .v-icon,
.tree-node__icon-name .v-icon {
  color: var(--brand-secondary) !important;
}

.tree-action-icon--edit {
  color: var(--brand-secondary) !important;
}

.tree-action-icon--delete {
  color: var(--brand-primary) !important;
}

@media (max-width: 960px) {
  .menus-toolbar {
    padding: 10px;
    flex-wrap: wrap;
  }

  .menus-search {
    max-width: none;
  }

  .btn-primary-red {
    min-width: 0;
    padding: 0 12px;
  }

  .view-toggle {
    margin: 4px 0;
  }

  .tree-toolbar {
    flex-wrap: wrap;
  }

  .tree-toolbar__title {
    width: 100%;
  }

  .menus-tree ::v-deep .v-treeview-node__children {
    margin-left: 12px;
  }

  .tree-node__meta {
    gap: 6px;
  }
}
</style>
